import { jsonRequest } from "@/helpers/wordpress";

export async function getAllTerms(): Promise<any> {
  const response = await jsonRequest("GET", "inc_members_get_all_terms");
  return await response.json();
}
